// extracted by mini-css-extract-plugin
export var header = "surgeryType-module--header--9h3zr";
export var headerLeft = "surgeryType-module--headerLeft--TmvGM";
export var headerRight = "surgeryType-module--headerRight--4uX4u";
export var headerRightImage = "surgeryType-module--headerRightImage--8czj6";
export var heading = "surgeryType-module--heading--24MAa";
export var image = "surgeryType-module--image--9QkiB";
export var main = "surgeryType-module--main--v2GBi";
export var photos = "surgeryType-module--photos--tH33y";